import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SpreadPartial from '../spread-partial';

class Component extends BaseComponent {
    render({ positions }) {
        return (
            <horoscope-tarot-spread>
                {this.renderImg()}
                <SpreadPartial positions={positions.map((p, i) => ({...p, card_index: i}))} />
            </horoscope-tarot-spread>
        );
    }

    renderImg = () => {
        if (this.props.cards.length < 12) {
            const base_url = 'https://gfx.tarot.com/images/site/tarot/horoscope-tarot-redux/';
            const src = `${base_url}${this.props.cards.length + 1}.svg`;

            return (
                <img src={src} className='position-img' />
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    positions: state['tarot-reading'] && state['tarot-reading'].positions,
    cards: state['tarot-reading'] && state['tarot-reading'].cards,
});

export default connect(mapStateToProps)(Component);
